import Resource from './Resource';

export default class ClassPageSection extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {}
		} = options;

		let config = {
			route: 'class-pages/:courseSectionGuid/pages/:folderId',
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
